import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/pie-chart/pages/CalculatorPage";

export const Route = createFileRoute("/pie-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/pie-chart",
      title: m.pie_meta_title(),
      description: m.pie_meta_description(),
      toolName: m.pie_tool_name(),
      faqs: [
        { q: m.pie_faq_q1(), a: m.pie_faq_a1() },
        { q: m.pie_faq_q2(), a: m.pie_faq_a2() },
        { q: m.pie_faq_q3(), a: m.pie_faq_a3() },
        { q: m.pie_faq_q4(), a: m.pie_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
